import type { ReactNode } from "react";
import PageSection from "./PageSection";
import SmartCtaLink, { type CtaAction } from "./SmartCtaLink";

/**
 * Финальный CTA страницы. Один и тот же блок внизу каждой публичной страницы:
 * раньше на части страниц его не было вовсе, а на других он был размазан.
 * Слот children — для мелких деталей вроде контактов под кнопками.
 */
export default function PageCta({
  title,
  description,
  actions,
  id,
  children,
}: {
  title: string;
  description?: string;
  actions: CtaAction[];
  id?: string;
  children?: ReactNode;
}) {
  return (
    <PageSection id={id}>
      <div className="rounded-3xl border border-white/10 bg-white/5 p-6 md:flex md:items-center md:justify-between md:gap-8 md:p-10">
        <div className="max-w-2xl">
          <h2 className="text-xl font-semibold tracking-tight text-white md:text-2xl">{title}</h2>
          {description ? (
            <p className="mt-2 text-sm leading-relaxed text-white/60">{description}</p>
          ) : null}
        </div>
        {actions.length > 0 ? (
          <div className="mt-6 flex flex-wrap gap-3 md:mt-0 md:shrink-0">
            {actions.map((action) => (
              <SmartCtaLink key={`${action.href}-${action.label}`} {...action} />
            ))}
          </div>
        ) : null}
      </div>
      {children ? <div className="mt-5">{children}</div> : null}
    </PageSection>
  );
}
